import React, { useState, useEffect } from 'react';
import Image from '../../../components/atom/image';
import './shared.css';
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import Api from "../../../services/loginApi"
import Cookie from '../../../lib/cookie';
import { getDecryptedItem, setEncryptedItem } from '../../../helper/methods';

let api = new Api()
let cookie = new Cookie();

const Navbar = (props) => {
  const history = useHistory();
  const [navType, setNavType] = useState('');
  const [productData, setProductData] = useState([]);
  const [selectedProduct, setselectedProduct] = useState('');
  const [fnameFromLS, setFnameFromLS] = useState("");
  // let getArn = useSelector(state => state.Auth.arnDetails);
  const stateData = useSelector(state => state.initApp.myzone.userInfo || "")
  let productDtlsFromLS = getDecryptedItem('productDtls');
  let productNames = localStorage.getItem("onlyProductNames");
  let redirectedProduct = localStorage.getItem("redirectDitUrl");
  // let panNumber = localStorage.getItem('uniqueKey');
  let panNumber = localStorage.getItem("PANentered");

  const navTypeClick = (data) => {
    if (navType === data) {
      setNavType('')
    } else {
      setNavType(data)
    }

  }

  const productsJson = [{
    "Heading": "ALL",
    "url": "/AllDasboard",
    "internal": true,
    "filter": "ALL"
  },
  {
    "Heading": "Mutual Fund",
    "url": "/business-dashboard",
    "internal": true,
    "filter": "MF"
  },
  {
    "Heading": "PMS",
    "url": "/pmsPage",
    "internal": false,
    "filter": "PMS"
  },
  {
    "Heading": "AIF",
    "url": "/aifPage",
    "internal": false,
    "filter": "AIF"
  }
  ]

  const handleLogout = () => {
    const disType = cookie.getCookie('distype')
    let redirectDitUrl = localStorage.getItem('redirectDitUrl');
    localStorage.clear();
    if (redirectDitUrl !== null && redirectDitUrl !== 'null') { 
      api.logout()
      history.push('/logoutDit')
      // window.location.href = '/logoutDit'
    } else {
      if (disType.toLowerCase() === "pms") {
        window.location.href = process.env.REACT_APP_DIT_PMS_ABSOLUTE_URL
      } else if (disType.toLowerCase() === "aif") {
        window.location.href = process.env.REACT_APP_DIT_AIF_ABSOLUTE_URL
      }
    }
    // history.push('/')
    api.logout()
  }

  useEffect(() => {
    if (productDtlsFromLS) {
        let parsedProductDtls = productDtlsFromLS;

        if (parsedProductDtls && Array.isArray(parsedProductDtls)) {
            let aifProduct = parsedProductDtls.find(item => item?.productType === "AIF");

            if (aifProduct) {
                setFnameFromLS(aifProduct?.fName || ""); // Safely access fName
            }
        }
    }
}, [productDtlsFromLS]);

  useEffect(() => {
    let getNavbar = document.querySelectorAll('.navbarTop .nav-item');
    getNavbar.forEach((el) => {
      el.addEventListener('mouseover', function (curr) {
        console.log(el.childNodes, 'el.childNodes', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.add('show');
          el.classList.add('show');
        }

      });
      el.addEventListener('mouseout', function (curr) {
        console.log(el.childNodes, 'el.childNodesover', curr)
        if (el.childNodes[1] !== undefined) {
          el.childNodes[1].classList.remove('show');
          el.classList.remove('show');
        }

      });
    })
  }, [])

  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  useEffect(() => { console.log(stateData, "stateData") }, [stateData])
  let customerName = "";
  if (stateData !== "") {

    customerName = stateData.name

  }

  const productNamesArray = productNames?.split(',');

  useEffect(() => {

    let filteredProducts
    if (productNamesArray) {
      filteredProducts = productsJson.filter((product) => {
        if (productNamesArray.length === 1) {
          if (productNamesArray.includes(product.filter)) {
            return true;
          }
          return false;
        } else {
          if (product.filter === "ALL" || productNamesArray.includes(product.filter)) {
            return true;
          }
          return false;
        }
      });
    }

    setProductData(filteredProducts);
  }, [productNames])

  useEffect(() => {
    setselectedProduct(redirectedProduct);
  }, [redirectedProduct]);

  useEffect(() => {
    if(props.disTypeFromPR && props.disTypeFromPR === 'AIF') {
      setselectedProduct('AIF')
    }
  },[])

  const handleClick = (data) => {
    let parsedPanData = panNumber;
    // let productDtls = getDecryptedItem('productDtls');
    // let productDtlsParsed = productDtls;
    let prodData = JSON.parse(productDtlsFromLS);
    const filterValue = data?.filter;
    setselectedProduct(filterValue);
    console.log("checking at line 146: ", filterValue)
    localStorage.setItem('redirectDitUrl', filterValue)
    let arnCodeValue;
    if (filterValue === "ALL") {
      arnCodeValue = prodData.find(product => product.productType === "MF")?.arnno;
    } else {
      const matchingProduct = prodData.find(product => product.productType === filterValue);
      arnCodeValue = matchingProduct?.arnno;
    }
    console.log("checking at line 156: ", filterValue, prodData, arnCodeValue);

    if (arnCodeValue) {
      localStorage.setItem('ARNCode', arnCodeValue);
    }

    if (filterValue === 'MF' || filterValue === 'ALL') {
      let productDetailsData = prodData?.filter(obj => obj.productType === 'MF');
      let { fName } = productDetailsData;
      setEncryptedItem("uniqueKey", { panNo: parsedPanData, nameAsOnPan: fName, productType: filterValue });
      localStorage.setItem("authDetailsForMF", JSON.stringify(productDetailsData?.[0]));
  
      if (filterValue === 'MF') {
        history.push('/mfAuth');
      } else if (filterValue === 'ALL') {
        history.push('/allAuth');
      }
    } else if (filterValue === 'PMS') {
      let productDetailsData = prodData?.filter(obj => obj.productType === 'PMS');
      let { fName } = productDetailsData;
      setEncryptedItem("uniqueKey", { panNo: parsedPanData, nameAsOnPan: fName, productType: filterValue });
      history.push('/pmsAuth');
    } else if (filterValue === 'AIF') {
      setselectedProduct('AIF')
      cookie.setCookieNew('distype', 'AIF');
      window.dispatchEvent(new Event('cookieChanged'));
    }
  }

  console.log("checking at line 183: ", selectedProduct);

  return (
    <React.Fragment>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">



        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo" href="#">
            {/* <img src="assets/images/logo.svg" alt="logo" /> */}
            <Image image="nav/moamc-logo-new.png" alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini" href="#">
            <Image image="nav/mf-m-min-logo.svg" alt="logo" />
            {/* <img src="assets/images/logo-mini.svg" alt="logo" /> */}
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-stretch">
          <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize" onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
            <span className="mdi mdi-menu"></span>
          </button>

          <ul className='navbar-nav navbar-nav-left navbarTop'>
            {
              productData?.map((curr, index) => {
                return (
                  <li id="menu-item-704" key={index} className={`menu-item menu-item-type-custom menu-item-object-custom menu-item-704 ${curr.filter === selectedProduct ? 'active' : ''}`}>
                    <div onClick={() => handleClick(curr)}>{curr.Heading}</div></li>
                )
              })
            }
          </ul>

          <ul className="navbar-nav navbar-nav-right navbarTop">

            <li className="nav-item nav-profile dropdown mobile_hover" >
              <a className="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
                <div className="nav-profile-img">
                  <Image image="nav/profile-icon.png" class="mobileProfile" alt="image" />
                </div>
                <div className="nav-profile-text">
                  <p className="mb-1 text-black">{fnameFromLS ? fnameFromLS : customerName}</p>
                </div>
              </a>

              <div className="dropdown-menu navbar-dropdown mobile_open dropdown-menu-right p-0 border-0 font-size-sm" aria-labelledby="profileDropdown" id="myDIV" data-x-placement="bottom-end">

                <div className="p-2">
                  {/* <h5 onClick={closePOpUp} className="dropdown-header text-uppercase pl-2 text-dark">User Options</h5> */}

                  {/* <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={gotoContactUs}>
            <span>Contact Us</span>
            <span className="p-0">
            </span>
          </a> */}
                  {/* <a onClick={closePOpUp} className="dropdown-item py-1 d-flex align-items-center justify-content-between" href="/aif/profile">
            <span>Profile</span>
            <span className="p-0">
              <i className="mdi mdi-account-outline ml-1"></i>
            </span>
          </a> */}

                  <div role="separator" className="dropdown-divider"></div>
                  {/* <h5 className="dropdown-header text-uppercase  pl-2 text-dark mt-2">Actions</h5> */}

                  <a className="dropdown-item py-1 d-flex align-items-center justify-content-between" onClick={handleLogout}>
                    <span>Log Out</span>
                    <i className="mdi mdi-logout ml-1"></i>
                  </a>
                </div>
              </div>
            </li>

          </ul>
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas" onClick={() => toggleOffcanvas()} id="mobileBAR">
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
      </nav>
    </React.Fragment>
  )
}

export default Navbar